module.exports = __webpack_public_path__ + "static/media/rsvp-promo-image.78b6d33e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/website/rsvp/rsvp-promo-image.png
// module id = 1775
// module chunks = 50